export enum CustomerBrand {
  Brighterly = 'BRIGHTERLY',
  SmartestMinds = 'SMARTESTMINDS',
}
